import React from 'react';
import Header from './Header';

const Splash = ({ form, onStart }) => {
    return (
        <div className="text-center">
            <div className="d-flex justify-content-center mb-4">
                <div className="icon-box bg-opacity-10 text-dark rounded-circle p-3">
                    <i className="bi bi-clipboard2-pulse fs-3"></i>
                </div>
            </div>
            <h4 className="fw-bold mb-4">{form?.title} Assessment</h4>
            <div className="">
                <h6 className="fw-semibold">Do you agree to the following?</h6>
                <div className="text-start mt-3">
                    <p className="text-muted mb-2">
                        • You are completing this consultation for yourself and to the best of your knowledge.
                    </p>
                    <p className="text-muted mb-2">
                        • You will disclose any medical conditions, serious illnesses or operations you have had.
                    </p>
                    <p className="text-muted mb-2">
                        • You will disclose any prescription medications you are currently taking and agree to use only one weight loss treatment at a time.
                    </p>
                    <p className="text-muted mb-2">
                        • You agree to our Terms & Conditions, Terms of Sale, and confirm that you have read our Privacy Policy.
                    </p>
                    <p className="text-muted mt-3">
                        Your accurate and honest responses to this online questionnaire for weight loss treatment are crucial. Withholding or providing false information can severely harm your health and may result in life-threatening consequences. By filling out this questionnaire, you confirm that your responses are truthful and accurate, acknowledging the potential risks of misinformation.
                    </p>
                </div>
                <button 
                    className="btncust activebg mt-4"
                    onClick={onStart}
                >
                    I Agree
                </button>
            </div>
        </div>
    );
};

export default Splash;